import seasonButtons from '../../../consts/seasonButtons';

export const initialFilterState = {
  seasonFilters: [...seasonButtons],
  brandFilters: [],
  minPrice: '',
  maxPrice: '',
  sortValue: '',
  searchOnlyInStock: false,
  loadIndexFilters: [],
  speedRatingFilters: [],
  fuelEfficiencyFilters: [],
  widthFilters: [],
  profileFilters: [],
  rimSizeFilters: [],
};

export const createFilterSlice = (set, get) => ({
  ...initialFilterState,

  setSeasonFilter: (seasonId, selected) => {
    set((state) => ({
      seasonFilters: state.seasonFilters.map((s) =>
        s.id === seasonId ? { ...s, selected } : s
      ),
    }));
  },

  setBrandFilter: (brandId, selected) => {
    set((state) => ({
      brandFilters: state.brandFilters.map((b) =>
        b.value === brandId ? { ...b, selected } : b
      ),
    }));
  },

  setMinPrice: (price) => set({ minPrice: price }),
  setMaxPrice: (price) => set({ maxPrice: price }),
  setSortValue: (value) => set({ sortValue: value }),
  setSearchOnlyInStock: (value) => set({ searchOnlyInStock: value }),

  setLoadIndexFilter: (value, selected) => {
    set((state) => ({
      loadIndexFilters: state.loadIndexFilters.map((f) =>
        f.value === value ? { ...f, selected } : f
      ),
    }));
  },

  setSpeedRatingFilter: (value, selected) => {
    set((state) => ({
      speedRatingFilters: state.speedRatingFilters.map((f) =>
        f.value === value ? { ...f, selected } : f
      ),
    }));
  },

  setFuelEfficiencyFilter: (value, selected) => {
    set((state) => ({
      fuelEfficiencyFilters: state.fuelEfficiencyFilters.map((f) =>
        f.value === value ? { ...f, selected } : f
      ),
    }));
  },

  setWidthFilter: (value, selected) => {
    set((state) => ({
      widthFilters: state.widthFilters.map((f) =>
        f.value === value ? { ...f, selected } : f
      ),
    }));
  },

  setProfileFilter: (value, selected) => {
    set((state) => ({
      profileFilters: state.profileFilters.map((f) =>
        f.value === value ? { ...f, selected } : f
      ),
    }));
  },

  setRimSizeFilter: (value, selected) => {
    set((state) => ({
      rimSizeFilters: state.rimSizeFilters.map((f) =>
        f.value === value ? { ...f, selected } : f
      ),
    }));
  },

  resetFilters: () => {
    set((state) => ({
      seasonFilters: state.seasonFilters.map((s) => ({ ...s, selected: false })),
      brandFilters: state.brandFilters.map((b) => ({ ...b, selected: false })),
      searchValue: '',
      vehicleSearch: null,
      searchOnlyInStock: false,
      minPrice: '',
      maxPrice: '',
      sortValue: '',
      loadIndexFilters: state.loadIndexFilters.map((f) => ({ ...f, selected: false })),
      speedRatingFilters: state.speedRatingFilters.map((f) => ({ ...f, selected: false })),
      fuelEfficiencyFilters: state.fuelEfficiencyFilters.map((f) => ({ ...f, selected: false })),
      widthFilters: state.widthFilters.map((f) => ({ ...f, selected: false })),
      profileFilters: state.profileFilters.map((f) => ({ ...f, selected: false })),
      rimSizeFilters: state.rimSizeFilters.map((f) => ({ ...f, selected: false })),
    }));
  },

  // Selectors
  getSelectedSeasons: () => {
    return get()
      .seasonFilters.filter((s) => s.selected)
      .map((s) => s._id)
      .filter(Boolean);
  },

  getSelectedBrands: () => {
    return get()
      .brandFilters.filter((b) => b.selected)
      .map((b) => b.value);
  },

  getActiveSeasons: () => {
    return get().seasonFilters.filter((s) => s.selected);
  },

  getActiveBrands: () => {
    return get().brandFilters.filter((b) => b.selected);
  },

  initializeFiltersFromResults: (tyresList) => {
    const state = get();

    // Only initialize if filters are empty
    if (state.loadIndexFilters.length > 0) return;

    const loadIndexSet = new Set();
    const speedRatingSet = new Set();
    const fuelEfficiencySet = new Set();
    const widthSet = new Set();
    const profileSet = new Set();
    const rimSizeSet = new Set();

    tyresList.forEach((tyre) => {
      if (tyre.load) loadIndexSet.add(tyre.load);
      if (tyre.speed) speedRatingSet.add(tyre.speed);
      if (tyre.fuel) fuelEfficiencySet.add(tyre.fuel);

      if (tyre.dimensions) {
        const match = tyre.dimensions.match(/(\d{3})\/(\d{2})\s?R?(\d{2})/i);
        if (match) {
          widthSet.add(match[1]);
          profileSet.add(match[2]);
          rimSizeSet.add(match[3]);
        }
      }
    });

    set({
      loadIndexFilters: Array.from(loadIndexSet)
        .sort()
        .map((val) => ({ value: val, label: val, selected: false })),
      speedRatingFilters: Array.from(speedRatingSet)
        .sort()
        .map((val) => ({ value: val, label: val, selected: false })),
      fuelEfficiencyFilters: Array.from(fuelEfficiencySet)
        .sort()
        .map((val) => ({ value: val, label: `Razred ${val}`, selected: false })),
      widthFilters: Array.from(widthSet)
        .sort()
        .map((val) => ({ value: val, label: `${val} mm`, selected: false })),
      profileFilters: Array.from(profileSet)
        .sort()
        .map((val) => ({ value: val, label: val, selected: false })),
      rimSizeFilters: Array.from(rimSizeSet)
        .sort((a, b) => parseInt(a) - parseInt(b))
        .map((val) => ({ value: val, label: `${val}"`, selected: false })),
    });
  },
});
